<template>
  <div class="go-in">
    <banner img="../assets/img/bgtop.jpg" title="关于我们" />
    <div class="section" v-loading="loading">
      <div class="section-content">
        <div id="summary" class="content-summary">
          <div class="summary-left">
            <p class="title">公司简介</p>
            <p class="eTitle">ABOUT US</p>
            <p class="content">
              {{ companyIntro }}
            </p>
          </div>
          <div class="summary-right">
            <img src="../assets/img/jianjietopmin.jpg" alt />
          </div>
        </div>
        <!-- 发展历程 -->
        <el-divider id="course" class="el-divider-active">
          <i class="el-icon-arrow-down el-icon-arrow-down-active"></i>
        </el-divider>
        <div  class="content-course">
          <div class="top">
            <h3>发展历程</h3>
            <p>DEVELOPMENT</p>
            <div class="border"></div>
            <div class="timeline"></div>
          </div>
          <div class="course-time">
            <swiper :options="swiperOption" ref="mySwiper">
              <swiper-slide v-for="(item, index) in courseList" :key="index">
                <div class="time-show">
                  <div class="time-show-item" v-for="(courseOne, one) in item" :key="one">
                    <div class="item-top" :class="{ 'order-top': one % 2 === 1 }"></div>
                    <el-divider>
                      <i class="el-icon-mobile-phone"></i>
                    </el-divider>
                    <div class="item-bottom" :class="{ 'order': one % 2 === 1 }">
                      <div class="item-bottom-content">
                        <p class="year">{{ courseOne.month }}</p>
                        <p class="details">
                          <template v-for="(c, index) in courseOne.content.split('\n')">
                            <span :key="index" style="display: block;">{{ c }}</span>
                          </template>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </div>
        </div>

        <div id="culture" class="content-culture">
          <h3>企业文化</h3>
          <h3>CULTURE</h3>
          <p>用节能环保的汽车技术服务社会</p>
          <span>企业目标：打造环保节能汽车技术的领军者</span>
          <span>企业精神：坚持创新、担当责任、挑战自我</span>
          <span>工作作风：不为问题找理由、只为进步找方法</span>
          <span>服务意识：把方便送给客户，把困难留给自己</span>
          <span>团队合作：把公司当成家就是主人，把主人当自己就是责任</span>
        </div>
        <!-- 团队风采 -->
        <div id="team" class="content-team">
          <div class="top">
            <h3>团队风采</h3>
            <p>TEAM</p>
            <div class="border"></div>
          </div>
          <el-carousel :interval="4000" type="card" style="margin-top: 10px;">
            <el-carousel-item v-for="(team, index) in teamItem" :key="index">
              <img class="swiper-img" v-lazy="imgurl + team.imgId"
                @click="dialogTableVisible = true; dialogUrl = imgurl + team.imgId; dialogTitle = team.remark" />
            </el-carousel-item>
          </el-carousel>
          <!-- <p>点击图片查看大图</p> -->
        </div>
        <!-- 公司荣誉 -->
        <div id="honor" class="content-honor">
          <div class="top">
            <h3>公司荣誉</h3>
            <p>HONOR</p>
            <div class="border"></div>
          </div>

          <!-- <ul class="honor-show">
            <li v-for="(honor, index) in honorList" :key="index">
              <img v-lazy="imgurl + honor.imgId"
                @click="dialogTableVisible = true; dialogUrl = imgurl + honor.imgId; dialogTitle = honor.remark" />
            </li>
          </ul> -->
          <el-carousel :interval="4000" type="card" style="margin-top: 10px;">
            <el-carousel-item v-for="(honor, index) in honorList" :key="index">
              <img class="swiper-img" v-lazy="imgurl + honor.imgId"
                @click="dialogTableVisible = true; dialogUrl = imgurl + honor.imgId; dialogTitle = honor.remark" />
            </el-carousel-item>
          </el-carousel>
          
          <!-- <p>点击图片查看大图</p> -->
        </div>

        <!-- 查看大图 -->
        <div class="big-img">
          <el-dialog :title="dialogTitle" :visible.sync="dialogTableVisible">
            <img v-lazy="dialogUrl" alt />
          </el-dialog>
        </div>
        <!-- 合作伙伴 -->
        <!-- <div class="content-partner">
          <div class="top">
            <h3>合作伙伴</h3>
            <p>RARTNERS</p>
            <ul class="partner-img">
              <li v-for="(partner,i) in partnerImg" :key="i">
                <img v-lazy="imgurl + partner.imgId" alt />
              </li>
            </ul>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    Banner,
    swiper,
    swiperSlide
  },
  data() {
    return {
      loading: true,
      honorList: [],
      partnerImg: [],
      courseList: [],
      teamItem: [],
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      dialogTableVisible: false,
      dialogUrl: "",
      dialogTitle: "",
      companyIntro: "",
    };
  },
  mounted() {
    this.http
      .all([
        this.http.get("/honor/list"),
        this.http.get("/enterprise/list"),
        this.http.get(`/team/list`),
        this.http.get(`/basic/course/list`),
        this.http.get(`/basic/data-dictionary?key=公司简介中文`),
      ])
      .then(
        this.http.spread(
          (responseHonor, responseEnterprise, responseTeam, responseCourse, responseComp) => {
            this.honorList = responseHonor.data;
            this.partnerImg = responseEnterprise.data;
            this.teamItem = responseTeam.data;
            this.companyIntro = responseComp.data.content;

            var groupCount = Math.ceil(responseCourse.data.length / 2);
            for (let i = 0; i < groupCount; i++) {
              let img2 = [];
              for (let j = 0; j < 2; j++) {
                if (responseCourse.data.length - 1 >= i * 2 + j) {
                  img2.push(responseCourse.data[i * 2 + j]);
                }
              }
              this.courseList.push(img2);
            }
            this.loading = false;
          }
        )
      );
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.go-in {
  width: 100%;
  height: 100%;
  background-color: #002057;
  position: relative;
  overflow: hidden;

  .section {
    width: 100%;

    &-content {
      width: 1240px;
      margin: 0 auto;
      background-color: #fff;

      .content-summary {
        //height: 500px;
        display: flex;
        justify-content: space-around;
        padding: 100px 0;

        .summary-left {
          width: 600px;

          .title {
            font-size: 25px;
            color: #004098;
          }

          .eTitle {
            font-size: 17px;
            color: #004098;
            padding: 20px 0;
          }

          .content {
            color: grey;
            font-size: 14px;
            text-indent: 25px;
            line-height: 30px;
          }
        }

        .summary-right {
          width: 400px;
          height: 310px;
          border: 2px solid #1d42b9;
          //animation: imgboxkey 4s infinite;
          border-radius: 10px;
          margin-top: 80px;
          text-align: center;

          img {
            width: 360px;
            height: 270px;
            margin-top: 20px;
            //animation: imgbo 4s infinite;
          }
        }
      }

      //发展历程
      .content-course {
        padding: 50px 0;

        .course-time {
          width: 1000px;
          height: 400px;
          margin: 20px auto;

          .swiper-container {
            height: 100%;
          }

          .time-show {
            width: 700px;
            height: 100%;
            margin: 0 auto;
            display: flex;

            .time-show-item {
              width: 350px;
              height: 100%;
              overflow: hidden;
              display: flex;
              flex-direction: column;

              .item-top,
              .item-bottom {
                height: 190px;
              }

              .item-bottom {

                // display: flex;
                // align-content: center;
                .item-bottom-content {
                  background-color: #1667a0;
                  margin: 20px 0;

                  .year {
                    color: #fff;
                    text-align: center;
                    padding: 15px 15px 0 15px;
                    font-weight: bold;
                  }

                  .details {
                    color: #fff;
                    text-align: left;
                    font-size: 12px;
                    padding: 15px;
                  }
                }
              }
            }
          }
        }
      }

      //企业文化
      .content-culture {
        height: 450px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        padding-left: 100px;
        background-color: #c2daeb;

        h3 {
          color: #3c6088;
          font-size: 26px;
        }

        p {
          color: #3c6088;
          font-size: 26px;
          padding: 5px 0;
        }

        span {
          font-weight: 400;
          line-height: 36px;
          font-size: 18px;
          padding: 5px 0;
        }
      }

      //公司荣誉
      .content-honor {
        // padding: 50px 0;

        // .honor-show {
        //   width: 1000px;
        //   margin: 30px auto;
        //   display: flex;
        //   flex-wrap: wrap;
        //   justify-content: flex-start;
        //   align-content: flex-start;

        //   li {
        //     width: 220px;
        //     // height: 320px;
        //     margin-left: 15px;
        //     list-style: none;
        //     border: 1px solid palegoldenrod;

        //     img {
        //       width: 100%;
        //       cursor: pointer;
        //       // height: 100%;
        //     }
        //   }
        // }

        padding: 50px 100px;

        .swiper-img {
          // height: 400px;
          width: 100%;
          background: no-repeat center;
          // background-size: cover;
        }

        p {
          text-align: center;
          color: #3c6088;
        }
      }

      //团队风采
      .content-team {
        padding: 50px 100px;

        .swiper-img {
          // height: 400px;
          width: 100%;
          background: no-repeat center;
          // background-size: cover;
        }

        p {
          text-align: center;
          color: #3c6088;
        }
      }

      //合作伙伴
      .content-partner {
        padding: 50px 0;

        .partner-img {
          width: 950px;
          margin: 20px auto;
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;

          li {
            width: 107px;
            height: 107px;
            list-style: none;
            margin: 10px 25px;

            img {
              width: 100%;
              height: 100%;
              border: 1px solid rgb(194, 218, 235);
            }
          }
        }
      }
    }
  }
}

@keyframes imgboxkey {
  0% {
    border: solid rgb(29, 66, 185) 2px;
  }

  40% {
    border: solid rgb(255, 255, 255) 2px;
  }

  60% {
    border: solid rgb(255, 255, 255) 2px;
  }

  100% {
    border: solid rgb(29, 66, 185) 2px;
  }
}

@keyframes imgbo {
  0% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }

  50% {
    transform: scale(1.1);
    box-shadow: 0px 0px 10px 5px #ababab;
  }

  100% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
}

.el-divider--horizontal {
  margin: 1px 0;
}

.top {

  h3,
  p {
    text-align: center;
    color: #3c6088;
    font-weight: 400;
    padding: 10px 0;
  }

  h3 {
    font-size: 30px;
  }

  p {
    font-size: 20px;
  }

  .border {
    border-bottom: 1px solid #3c6088;
    width: 15%;
    margin: 0 auto;
  }
}

// .swiper-button-disabled {
//   display: none;
// }
.order {
  order: -1;
}

.order-top {
  order: 1;
}

.el-divider {
  background-color: red;
  height: 3px;

  .el-divider__text {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    padding: 0px;
    color: #fff;
    border: 3px solid red;
  }
}

.el-divider-active {
  background-color: #3c6088;
}

.big-img {
  width: 100%;
  height: 100%;
  z-index: 10;
  text-align: center;
  // padding-bottom: 20px;
  // padding: 5%;

  //background-color: #002057;
  .el-dialog__wrapper {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;

    .el-dialog__body {
      overflow: hidden;

      img {
        width: 100%;
      }
    }
  }
}
</style>